// src/managerPortal/components/modals/EventModal.js
import React, { useState, useEffect } from "react";
import "../../styles/Modals.css";

const EventModal = ({ mode, eventData, onClose, onAdd, onEdit }) => {
    // Local state for form fields and errors
    const [title, setTitle] = useState("");
    const [date, setDate] = useState("");
    const [time, setTime] = useState("");
    const [imageFile, setImageFile] = useState(null);
    const [errors, setErrors] = useState({});

    // If editing, populate initial values (imageFile is not prefilled)
    useEffect(() => {
        if (mode === "edit" && eventData) {
            setTitle(eventData.title || "");
            setDate(eventData.date || "");
            setTime(eventData.time || "");
        }
    }, [mode, eventData]);

    const handleImageChange = (e) => {
        setImageFile(e.target.files[0]);
    };

    // Validate required fields and display error messages if any are empty
    const handleSubmit = (e) => {
        e.preventDefault();
        let newErrors = {};

        if (!title.trim()) newErrors.title = "Title is required.";
        if (!date.trim()) newErrors.date = "Date is required.";
        if (!time.trim()) newErrors.time = "Time is required.";
        // For add mode, require the image file as well
        if (mode === "add" && !imageFile) newErrors.imageFile = "Event image is required.";

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        // Clear errors if validation passes
        setErrors({});

        // Prepare FormData with all fields
        const formData = new FormData();
        formData.append("title", title);
        formData.append("date", date);
        formData.append("time", time);
        if (imageFile) {
            formData.append("image", imageFile);
        }

        if (mode === "add") {
            onAdd(formData);
        } else if (mode === "edit" && eventData?._id) {
            onEdit(eventData._id, formData);
        }
    };

    const availableTimes = [
        "7 PM", "7:30 PM", "8 PM", "8:30 PM",
        "9 PM", "9:30 PM", "10 PM", "10:30 PM",
        "11 PM", "11:30 PM", "12 AM", "12:30 AM",
      ];

    return (
        <div
          className="modal-backdrop"
          onClick={(e) => {
            if (e.target.classList.contains("modal-backdrop")) {
              onClose();
            }
          }}
        >
            <div className="modal-container">
                <h2>{mode === "add" ? "Add New Event" : "Edit Event"}</h2>
                <form onSubmit={handleSubmit} className="event-form">

                    {/* Image Upload (side-by-side preview & input) */}
                    <div className="form-group">
                        <label htmlFor="imageFile">
                            Event Image: <span className="required">*</span>
                        </label>

                        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                            {/* If in edit mode and there's an existing image, show a preview */}
                            {mode === "edit" && eventData?.image && (
                                <div className="image-preview">
                                    <img
                                        src={eventData.image}
                                        alt="Current Event"
                                        style={{
                                            maxWidth: "100px",
                                            maxHeight: "100px",
                                            border: "1px solid #ccc",
                                            objectFit: "cover"
                                        }}
                                    />
                                </div>
                            )}

                            <input
                                type="file"
                                id="imageFile"
                                accept="image/*"
                                onChange={handleImageChange}
                            />
                        </div>

                        {errors.imageFile && <span className="error">{errors.imageFile}</span>}
                    </div>

                    {/* Title */}
                    <div className="form-group">
                        <label htmlFor="eventTitle">
                            Title: <span className="required">*</span>
                        </label>
                        <input
                            type="text"
                            id="eventTitle"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="Enter event title"
                        />
                        {errors.title && <span className="error">{errors.title}</span>}
                    </div>

                    {/* Date */}
                    <div className="form-group">
                        <label htmlFor="eventDate">
                            Date: <span className="required">*</span>
                        </label>
                        <input
                            type="date"
                            id="eventDate"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                            required
                        />
                        {errors.date && <span className="error">{errors.date}</span>}
                    </div>

                    {/* Time */}
                    <div className="form-group">
                        <label htmlFor="eventTime">
                            Time: <span className="required">*</span>
                        </label>
                        <select
                            id="eventTime"
                            value={time}
                            onChange={(e) => setTime(e.target.value)}
                            required
                        >
                            <option value="">-- Select a time --</option>
                            {availableTimes.map((t) => (
                                <option key={t} value={t}>
                                    {t}
                                </option>
                            ))}
                        </select>
                        {errors.time && <span className="error">{errors.time}</span>}
                    </div>

                    {/* Modal Actions */}
                    <div className="modal-actions">
                        <button type="button" className="btn-cancel" onClick={onClose}>
                            Cancel
                        </button>
                        <button type="submit" className="btn-submit">
                            {mode === "add" ? "Add Event" : "Save Changes"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EventModal;
